import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import BaseSelectPanel from './BaseSelectPanel'
import EmphasisHeading from '@pc/components/Works/Panel/shared/heading/EmphasisHeading'
import EmphasisSelectBox from '@pc/components/Works/Panel/shared/selectbox/EmphasisSelectBox'
import SelectOption from '@pc/components/Works/Panel/shared/selectbox/SelectOption'

import { buildDynamicSearchApiUrl } from '@pc/components/Works/Panel/util/workSearchApi'
import type { SearchParamsAttributes, Wages } from '@pc/components/Works/Panel/type'

interface PropsType {
  params: SearchParamsAttributes
}

const WageSelectBoxWrapper = styled.div`
  margin-top: 10px;
`

const WageSelectPanel = (props: PropsType) => {
  const { params } = props
  const [wages, setWages] = useState<Wages[]>([])

  const handleChange = (e: { target: HTMLSelectElement }) => {
    const value = e.target.value

    // 「希望なし」が選択された場合は検索条件から外す必要があるため。
    const salaryAmount = value !== '' ? value : null

    const mergedParams = { ...params, salary_amount: salaryAmount }
    const endPoint = buildDynamicSearchApiUrl(mergedParams)

    window.location.href = endPoint
  }

  const wageOptions = wages.map((wage: Wages) => {
    return (
      <SelectOption key={wage.id} value={wage.attributes.legacy_url_value}>
        {wage.attributes.name}
      </SelectOption>
    )
  })

  useEffect(() => {
    const el = document.querySelector<HTMLElement>('.js-works-search-panel')
    const wagesAttr = el?.dataset.worksWages
    if (wagesAttr === undefined) return

    const wagesJson: Wages[] = JSON.parse(wagesAttr).data
    setWages(wagesJson)
  }, [])

  return (
    <BaseSelectPanel>
      <EmphasisHeading>時給</EmphasisHeading>
      <WageSelectBoxWrapper>
        <EmphasisSelectBox value={params.salary_amount} onChange={handleChange} ariaLabel="時給を選択">
          <SelectOption value="">希望なし</SelectOption>
          {wageOptions}
        </EmphasisSelectBox>
      </WageSelectBoxWrapper>
    </BaseSelectPanel>
  )
}

export default WageSelectPanel
